import {
  ClipboardList,
  PlusCircle,
  CheckCircle,
  TrendingUp,
  Bell,
  Users,
  Database,
  // BarChart, TODO post MVP
  // Newspaper, TODO post MVP
  Gavel,
  Archive,
} from "lucide-react";

import { AuthUserDTORole } from "@/common/api";
import { ROUTES } from "@/common/config";
import { Permissions } from "@/common/hooks";

export interface NavigationItem {
  name: string;
  href: string;
  icon: any;
}

export const getNavigationForRole = (
  role: string | null,
  permissions: Permissions | null,
): NavigationItem[] => {
  switch (role) {
    case AuthUserDTORole.ADMIN:
      return [
        {
          name: "Все заявки",
          href: ROUTES.MODERATION_ORDERS,
          icon: TrendingUp,
        },
        {
          name: "Модерация",
          href: ROUTES.MODERATION,
          icon: CheckCircle,
        },
        {
          name: "Управление пользователями",
          href: ROUTES.USER_MANAGEMENT,
          icon: Users,
        },
        // { TODO post MVP
        //   name: "Управление контентом",
        //   href: "/content-management",
        //   icon: Newspaper,
        // },
        {
          name: "Справочники",
          href: ROUTES.DIRECTORIES,
          icon: Database,
        },
        // { name: "Отчеты", href: "/reports", icon: BarChart},
        {
          name: "Уведомления",
          href: ROUTES.NOTIFICATIONS,
          icon: Bell,
        },
      ];

    case AuthUserDTORole.WAGON_OWNER:
      return [
        {
          name: "Все заявки",
          href: ROUTES.ORDERS,
          icon: ClipboardList,
        },
        {
          name: "Мои участия в заявках на перевозку груза",
          href: ROUTES.SOB_ORDERS,
          icon: Gavel,
        },
        // { TODO post MVP
        //   name: "Мои заявки-предложения ПС",
        //   href: "/dashboard",
        //   icon: Archive,
        // },
        // { name: "Отчеты", href: "/reports", icon: BarChart},
        {
          name: "Уведомления",
          href: ROUTES.NOTIFICATIONS,
          icon: Bell,
        },
        // { TODO post MVP
        //   name: "Создать заявку-предложение подвижного состава",
        //   href: "/create-request",
        //   icon: PlusCircle,
        // },
      ];

    case AuthUserDTORole.CARGO_OWNER:
      const routes: NavigationItem[] = [
        {
          name: "Все заявки",
          href: ROUTES.TRADING,
          icon: ClipboardList,
        },
        {
          name: "Мои заявки на перевозки груза",
          href: ROUTES.ROOT,
          icon: Archive,
        },
        // { TODO post MVP
        //   name: "Мои участия в торгах по заявкам-предложениям ПС",
        //   href: "/my-trades",
        //   icon: Gavel,
        // },
        // { name: "Отчеты", href: "/reports", icon: BarChart },
        {
          name: "Уведомления",
          href: ROUTES.NOTIFICATIONS,
          icon: Bell,
        },
      ];

      if (permissions?.applications.create_application) {
        routes.push({
          name: "Создать заявку на перевозку груза",
          href: ROUTES.CREATE_ORDER,
          icon: PlusCircle,
        });
      }

      return routes;

    default:
      return [];
  }
};
